module.exports = __webpack_public_path__ + "img/Spacer.4f85a8b9.svg";